import {Brand} from "@App/types";
import {Brands} from "@App/types/enums";

export const BrandIsMG = (brand: Brand) => {
    return brand?.id === Brands.MG;
}


export const BrandIsTesla = (brand: Brand) => {
    return brand?.id === Brands.TESLA;
}
export const BrandIs = (brandId: Brands, brand: Brand) => {
    return brand?.id === brandId;
}
